import * as Yup from 'yup';

export interface ICertificateSignatureInput {
  full_name: string;
  position: string;
  signature: any;
  id: number;
}

export const certificateSignatureInitialValues: ICertificateSignatureInput = {
  full_name: '',
  position: '',
  signature: '',
  id: 0
};

export const certificateSignatureSchemaValidation = Yup.object().shape({
  full_name: Yup.string().required('Name is required'),
  position: Yup.string().min(2, 'Too Short!').required('position is required'),
  signature: Yup.string().optional()
});
